import { APIService } from "../../../../network/api/APIService";

export const AppAnnouncementData = ({
    method = "GET",
    id = null,
    appId = null,
    formData = {},
}) => {
    let endpoint = "/app/announcement/";

    if (method === "GET" && id && appId) {
        endpoint += `?app_id=${encodeURIComponent(appId)}&id=${encodeURIComponent(id)}`;
    } else if (method === "DELETE" && id) {
        endpoint += `?id=${encodeURIComponent(id)}`;
    }

    const config = {
        endpoint,
        method,
        credentials: "include",
    };

    if (["POST", "PUT", "PATCH"].includes(method)) {
        config.data = formData;
    }

    return APIService(config);
};
